import { type ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';

export function MetadataElementList({
  title,
  values = [],
  children,
}: {
  title: string;
  values?: string[];
  children?: (val: string) => ReactNode;
}) {
  if (values.length === 0) {
    return null;
  }

  return (
    <>
      <Row className="mt-2">
        <strong>{title}</strong>
      </Row>
      {values.map((val) => (
        <Row key={val}>
          <Col>{children?.(val) || val}</Col>
        </Row>
      ))}
    </>
  );
}
